
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(834|99)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
